"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorMtaPremiumWordingGenerator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var commonFunctions_1 = require("../../../commonFunctions");
var MtaPremiumWording_1 = require("./MtaPremiumWording");
var AnnualMotorMtaPremiumWordingGenerator = /** @class */ (function () {
    function AnnualMotorMtaPremiumWordingGenerator() {
    }
    AnnualMotorMtaPremiumWordingGenerator.generateMtaPremiumWording = function (interaction, previousPolicyInteraction, price) {
        if (previousPolicyInteraction) {
            var addonsOrExcessesChanged = AnnualMotorMtaPremiumWordingGenerator.getAddonsOrExcessesChanged(previousPolicyInteraction, interaction);
            var additionalQuestionsChanged = AnnualMotorMtaPremiumWordingGenerator.getAdditionalQuestionsChangedCount(previousPolicyInteraction, interaction);
            var carsInHouseholdNotChanged = interaction.policyHolder.carsInHousehold === previousPolicyInteraction.policyHolder.carsInHousehold;
            var isAdditionalDriverEdited = AnnualMotorMtaPremiumWordingGenerator.isAdditionalDriverEdited(previousPolicyInteraction, interaction);
            var totalFieldsChanged = addonsOrExcessesChanged.length + additionalQuestionsChanged;
            var singleChangeWasMade = totalFieldsChanged === 1 && addonsOrExcessesChanged.length === 1 && !isAdditionalDriverEdited && carsInHouseholdNotChanged;
            var upgradeToAllianzWording = interaction.uistate.upgradeToAllianz ? "and upgrade to our Plus cover, our highest level of comprehensive insurance" : "";
            var isRefund = interaction.factors.amountToRefund > 0;
            if (singleChangeWasMade) {
                return AnnualMotorMtaPremiumWordingGenerator.wordingForSingleAddonOrExcessChange(addonsOrExcessesChanged[0].key, addonsOrExcessesChanged[0].state, interaction.vehicles[0], upgradeToAllianzWording, price);
            }
            else {
                return AnnualMotorMtaPremiumWordingGenerator.wordingForAnyOtherChangesMade(isRefund, upgradeToAllianzWording, price);
            }
        }
        else {
            return new MtaPremiumWording_1.MtaPremiumWording("", "", true);
        }
    };
    AnnualMotorMtaPremiumWordingGenerator.getAddonsOrExcessesChanged = function (previousPolicyInteraction, interaction) {
        var previousOptionalExtras = previousPolicyInteraction.optionalExtras;
        var optionalExtras = interaction.optionalExtras;
        var interactionAddonsAndExcesses = [
            { key: "familyPackage", state: optionalExtras.familyPackage },
            { key: "doNotDisclose", state: interaction.policyHolder.ncd.doNotDisclose }
        ];
        var policyAddonsAndExcesses = [
            { key: "familyPackage", state: previousOptionalExtras.familyPackage },
            { key: "doNotDisclose", state: previousPolicyInteraction.policyHolder.ncd.doNotDisclose }
        ];
        var results = [];
        interactionAddonsAndExcesses.forEach(function (i) {
            var differentValue = policyAddonsAndExcesses.find(function (policy) {
                return (policy.key === i.key) && (policy.state != i.state);
            });
            if (differentValue) {
                results.push(i);
            }
        });
        return results;
    };
    AnnualMotorMtaPremiumWordingGenerator.getAdditionalQuestionsChangedCount = function (policyInteraction, interaction) {
        var interactionVehicle = interaction.vehicles[0];
        var policyInteractionVehicle = policyInteraction.vehicles[0];
        var objectCarInteraction = [
            { key: "purchaseDate", value: interactionVehicle.purchaseDate },
            { key: "mileage", value: interactionVehicle.mileage },
            { key: "overnightLocationIsHome", value: interactionVehicle.overnightLocationIsHome },
            { key: "hasModifications", value: interactionVehicle.hasModifications }
        ];
        var objectCarPolicyInteraction = [
            { key: "purchaseDate", value: policyInteractionVehicle.purchaseDate },
            { key: "mileage", value: policyInteractionVehicle.mileage },
            { key: "overnightLocationIsHome", value: policyInteractionVehicle.overnightLocationIsHome },
            { key: "hasModifications", value: policyInteractionVehicle.hasModifications }
        ];
        var results = [];
        objectCarInteraction.forEach(function (interactionCar) {
            var differentValue = objectCarPolicyInteraction.find(function (policyInteraction) {
                return (interactionCar.key === policyInteraction.key) && (interactionCar.value !== policyInteraction.value);
            });
            if (differentValue) {
                results.push(policyInteraction);
            }
        });
        return results.length;
    };
    AnnualMotorMtaPremiumWordingGenerator.getDriverFieldsChangedCount = function (interactionPersons, policyInteractionPersons) {
        var difference = Object.keys(interactionPersons).filter(function (key) {
            if (key === "numberOfReadOnlyClaims" || key === "numberOfReadOnlyConviction" || key === "driverInfoEdited") {
                return;
            }
            else {
                return interactionPersons[key] !== policyInteractionPersons[key];
            }
        });
        return difference.length;
    };
    AnnualMotorMtaPremiumWordingGenerator.isAdditionalDriverEdited = function (policyInteraction, interaction) {
        var result = false;
        if ((policyInteraction.additionalDrivers && interaction.additionalDrivers) && (policyInteraction.additionalDrivers.length === interaction.additionalDrivers.length)) {
            var policyInteractionAdditionalDrivers_1 = AnnualMotorMtaPremiumWordingGenerator.flattenAdditionalDriversObject(policyInteraction.additionalDrivers);
            var interactionAdditionalDrivers_1 = AnnualMotorMtaPremiumWordingGenerator.flattenAdditionalDriversObject(interaction.additionalDrivers);
            var fieldsChanged_1 = 0;
            interactionAdditionalDrivers_1.forEach(function (driver, index) {
                fieldsChanged_1 += AnnualMotorMtaPremiumWordingGenerator.getDriverFieldsChangedCount(interactionAdditionalDrivers_1[index], policyInteractionAdditionalDrivers_1[index]);
            });
            result = fieldsChanged_1 > 0;
        }
        if (policyInteraction.additionalDrivers && !interaction.additionalDrivers) {
            result = false;
        }
        return result;
    };
    AnnualMotorMtaPremiumWordingGenerator.wordingForSingleAddonOrExcessChange = function (changedItemId, addedOrRemoved, vehicle, upgradeToAllianzWording, price) {
        var optionalExtrasMapping = [
            { key: "familyPackage", value: "Family package" },
            { key: "doNotDisclose", value: "Protected no claim discount" }
        ];
        var wordingToShow = optionalExtrasMapping.find(function (wording) { return wording.key === changedItemId; });
        var mtaDetailsWording = "for ".concat(addedOrRemoved ? "adding" : "removing", " ").concat(wordingToShow.value, " add-on to ").concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")");
        var wordingForPaymentReason = "".concat(addedOrRemoved ? "add" : "remove", " ").concat(wordingToShow.value);
        var prefix = !addedOrRemoved ? "from" : "to";
        return new MtaPremiumWording_1.MtaPremiumWording(((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold pt-2 mb-0", children: ["".concat(price || '', " to ").concat(wordingForPaymentReason, " ").concat(prefix, " ").concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")"), " ", upgradeToAllianzWording] }) }) })), mtaDetailsWording, false);
    };
    AnnualMotorMtaPremiumWordingGenerator.wordingForAnyOtherChangesMade = function (isRefund, upgradeToAllianzWording, price) {
        return new MtaPremiumWording_1.MtaPremiumWording(((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { className: "font-weight-bold pt-3 mb-0", children: [price !== null && price !== void 0 ? price : '', " ", isRefund ? "refund " : "", "for the changes you have made"] }), upgradeToAllianzWording] })), "genericMessage", true);
    };
    AnnualMotorMtaPremiumWordingGenerator.flattenAdditionalDriversObject = function (additionalDriverObject) {
        var resultArray = [];
        additionalDriverObject.forEach(function (driver) {
            var flattenedDriverObject = (0, commonFunctions_1.flattenObjectJson)(driver);
            resultArray.push(flattenedDriverObject);
        });
        return resultArray;
    };
    return AnnualMotorMtaPremiumWordingGenerator;
}());
exports.AnnualMotorMtaPremiumWordingGenerator = AnnualMotorMtaPremiumWordingGenerator;
//# sourceMappingURL=AnnualMotorMtaPremiumWordingGenerator.js.map